export default __webpack_public_path__ + "static/media/dot-shape.95009262.svg";